import { useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { motion, useScroll, useTransform, useSpring, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import '../css/sections.css'

import merch2000 from '../assets/merch2000.webp'
import merch9x16 from '../assets/merch9x16.jpg'

const MerchSection = ({ windowWidth }) => {

const [ ref, inView ] = useInView()
const targetRef = useRef()

const animation = useAnimation()
const animation2 = useAnimation()
const animation3 = useAnimation()


    const { scrollYProgress } = useScroll({
        target: targetRef,
        offset: ["start end", "end start"]
})

const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 20,
    mass: 0.2
  });

const y = useTransform(smoothProgress, [0, 1], [-100, 100])


useEffect(() => {
if(!inView) {
    animation.start({ y: '100%', transition: { ease: 'linear', duration: 0.5 } })
    animation2.start({ y: '100%', transition: { ease: 'linear', duration: 0.5 } })
    animation3.start({ y: '100%', transition: { ease: 'linear', duration: 0.5 } })
} else {
    animation.start({ y: '0vh', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.3 } })
    animation2.start({ y: '0vh', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.45 } })
    animation3.start({ y: '0vh', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.6 } })
    }
}, [inView])




return (
    <>
    <div ref={ targetRef } style={{ width: '100vw', height: '100vh', position: 'relative', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#000' }}>
        <motion.img src={ windowWidth > 700 ? merch2000 : merch9x16 } style={{ width: '105%', height: '105%', objectFit: 'cover', objectPosition: '50% 45%', position: 'absolute', y }} />
        <div className='general-grid' style={{ position: 'relative', backgroundColor: '#0001 ' }}>
            <div></div>
            <div>
                <div style={{ position: 'absolute', bottom: '5rem', lineHeight: '2.8em', filter: 'blur(0.5px)' }}>
                    <div style={{ overflow: 'hidden', height: '18px' }}>
                        <motion.h5 className='little' animate={ animation } style={{ position: 'relative' }}>SHOP GALANTIS</motion.h5>
                    </div>
                    <div ref={ ref } className='font-sizes' style={{ marginTop: '0.05em', position: 'relative', color: '#fff000' }}>
                        <div style={{ overflow: 'hidden' }}>
                            <motion.div animate={ animation2 }>
                                <motion.a href='https://galantis.merchtable.com/' target='_blank' whileHover={{ color: '#fff' }} style={{ textDecoration: 'none' }}>US  STORE&nbsp;</motion.a>
                                /<br />
                            </motion.div>
                        </div>
                        <div style={{ overflow: 'hidden' }}>
                            <motion.div animate={ animation3 }>
                                <motion.a href='https://100-percent.store/collections/galantis' target='_blank' whileHover={{ color: '#fff' }} style={{ textDecoration: 'none' }}>UK & EUROPE</motion.a>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </div>
            <div></div>
        </div>
    </div>
    </>
)
}

export default MerchSection